import { call, put, select, all, take, fork } from 'redux-saga/effects';
import { requestFields } from '../requesters/fieldsRequester';
import { receiveFields, fieldsFailure } from '../actions/fieldsActions';
import { receiveOperationsFields } from '../actions/operationsActions';
import { logDmbErrorLocation } from '../utils/error';
import { RECEIVE_OPERATIONS, RECEIVE_FIELDS } from '../constants/actionTypes';
import { shouldUseMocks } from '../utils/mocks';

/**
 * Requests the crop list and dispatches a receive action with the result since this endpoint is
 * paginated the token is sent until we get the entire response
 * @param {String} nextToken
 * @return {void}
 */
export function* getFields(nextToken) {
  const store = yield select();
  const { user } = store;
  const userId = user.isProxying ? user.id : null;
  try {
    const response = yield call(requestFields, userId, nextToken);
    if (response.status === 304) {
      return;
    }

    const { fields } = shouldUseMocks()
      ? response 
      : yield call([response, 'json']);
    yield put(receiveFields(fields));
    if (response.status === 206) {
      const token = response.headers.get('x-next-token');
      yield call(getFields, token);
    }
  } catch (error) {
    yield put(fieldsFailure());
    logDmbErrorLocation(error, 'Fields saga - requestFields');
  }
}

export function* receiveOperationsFieldsWatcher() {
  const [{ operations, operationId }, { payload: fields }] = yield all([
    take(RECEIVE_OPERATIONS),
    take(RECEIVE_FIELDS),
  ]);
  yield put(receiveOperationsFields(operations, operationId, fields));
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(receiveOperationsFieldsWatcher);
}
